import React from 'react';

import { Box, Button, Checkbox, FormControlLabel, FormGroup, FormLabel, Radio, RadioGroup, Stack } from '@mui/material';

import { TypeaheadPriority, TypeaheadType } from '~/services/SearchService';

type TypeaheadTypeSelection = Record<TypeaheadType, boolean>;

interface Props {
  setTypes: (types: TypeaheadTypeSelection) => void;
  setPriority: (priority: TypeaheadPriority) => void;
  types: TypeaheadTypeSelection;
  priority: TypeaheadPriority;
}

export default function PlaceSearchFormControls({ priority, setPriority, types, setTypes }: Props) {
  const setAllTypes = (selected: boolean) => {
    setTypes(Object.fromEntries(Object.keys(types).map((key) => [key, selected])) as TypeaheadTypeSelection);
  };

  return (
    <FormGroup>
      <FormLabel id="search-form-typeahead-priority">Priority Formula</FormLabel>
      <RadioGroup
        row
        aria-labelledby="search-form-typeahead-priority"
        name="row-radio-buttons-group"
        sx={{ alignItems: 'center' }}
      >
        <FormControlLabel
          value="current"
          control={<Radio checked={priority === 'current'} onChange={() => setPriority('current')} />}
          label="current"
        />

        <FormControlLabel
          value="next"
          control={<Radio checked={priority === 'next'} onChange={() => setPriority('next')} />}
          label="next"
        />
      </RadioGroup>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 1, mb: 1 }}>
        <FormLabel id="search-form-typeahead-types">Types</FormLabel>
        <Stack direction="row" spacing={1}>
          <Button size="small" variant="text" onClick={() => setAllTypes(true)}>
            Select All
          </Button>
          <Button size="small" variant="text" onClick={() => setAllTypes(false)}>
            Deselect All
          </Button>
        </Stack>
      </Box>
      {Object.keys(types).map((type) => (
        <FormGroup key={type}>
          <FormControlLabel
            control={
              <Checkbox
                onChange={() => setTypes({ ...types, [type]: !types[type] })}
                checked={types[type]}
                name={type}
              />
            }
            label={type}
          />
        </FormGroup>
      ))}
    </FormGroup>
  );
}
